import React from 'react';
import styles from '../../styles/RagIndicator.module.scss';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { RagColours } from '../../refData/RagColours';

export interface IRagIndicatorProps {
    rag: RagColours;
    label?: string;
}

export const RagIndicator = ({ rag, label }: IRagIndicatorProps): React.ReactElement => {
    return (
        <div className={styles.ragIndicator}>
            {rag === RagColours.DarkRed &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.darkRed}`}>
                    <TooltipHost content={label || 'Dark Red'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Dark Red'}
                    </TooltipHost>
                </div>
            }
            {rag === RagColours.Red &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.red}`}>
                    <TooltipHost content={label || 'Red'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Red'}
                    </TooltipHost>
                </div>
            }
            {rag === RagColours.Amber &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.amber}`}>
                    <TooltipHost content={label || 'Amber'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Amber'}
                    </TooltipHost>
                </div>
            }
            {rag === RagColours.Green &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.green}`}>
                    <TooltipHost content={label || 'Green'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Green'}
                    </TooltipHost>
                </div>
            }
            {rag === RagColours.DarkGreen &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.darkGreen}`}>
                    <TooltipHost content={label || 'Dark Green'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Dark Green'}
                    </TooltipHost>
                </div>
            }
            {(rag === null || rag === undefined) &&
                <div className={`${styles.fontSize14} ${styles.indicator} ${styles.grey}`}>
                    <TooltipHost content={label || 'Not Started'} overflowMode={TooltipOverflowMode.Parent}>
                        {label || 'Not Started'}
                    </TooltipHost>
                </div>
            }
        </div>
    );
};
